import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Gets the default inventory for a given facility
 *
 * @param {number} facilityId
 * @returns {Promise<TInventorySpaces>}
 * @throws {Error}
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_default_inventory
 * @see '/api/v1/facilities/{facilityId}/default-inventory/'
 */
const getDefaultInventory = async (facilityId) => {
    try {
        const {data} = await spotheroGet(
            `facilities/${facilityId}/default-inventory/`
        );

        return data?.data?.spaces || 0;
    } catch (err) {
        sendSentryException(err);

        throw new Error(err.message);
    }
};

export default getDefaultInventory;
